// VehRouteListMini.js
import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { Box } from '@mui/system';
import useClientSize from '../hook/useClientSize';
import CellTowerIcon from '@mui/icons-material/CellTower'; // cell position
import GpsFixedIcon from '@mui/icons-material/GpsFixed'; // speed < 2
import NavigationIcon from '@mui/icons-material/Navigation'; // speed >= 2
import ResponseAlert from "../message/ResponseAlert";
import FlexyTable from '../common/flexytable/FlexyTable';
import ValueUtil from '../../model/ValueUtil';
import { AppNumber, AppWord, AppObject, TableColumnType } from '../../model/AppConst';
import { useLazyQuery } from '@apollo/client';
import { LIST_VEH_ROUTE } from './VehRouteGql';
import dayjs from 'dayjs';

const dcPad = AppNumber.dataContainerPadding;
const VehRouteListContainer = styled(Box)({
    position:"absolute", top:0, right:0, bottom: 0, left: dcPad,
	display:'flex', flexDirection:'column', //border:'1px solid red', backgroundColor:'yellow'
});

const HeaderBox = styled(Box)({
    display:'flex', justifyContent:'start', alignItems:'center',
    height: AppNumber.HeaderToolBoxHeight,
    color: '#333',
    '&>*': {verticalAlign: 'middle'}
});

const StateColumn = {
    id:'-mv-mark', label:'상태', width:50, show: true,
    option: {
        aligh:'center', type: TableColumnType.GRAPH,
        form: (rec, rowIndx) => {
            if(rec.posSys==='C' || rec.posSys===null) return <CellTowerIcon fontSize={AppWord.SMALL} color='disabled' />
            if(rec.speed < 2) return <GpsFixedIcon fontSize={AppWord.SMALL} color='success'/>;
            return <NavigationIcon fontSize={AppWord.SMALL} color='primary' style={{transform: 'rotate('+rec.direction+'deg)'}}/>;
        }
    }
};

const TableColumns = [
    
    //{ id: 'vehPlates', label: '차량번호', width: 100, show: false, option:{align: 'inherit', type: TableColumnType.TEXT} },
    //{ id: 'vehAlias', label: '지도표시명', width: 100, show: false, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'gpsTime', label: '최종보고', width: 165, show: true, option:{align: 'inherit', type: TableColumnType.DATETIME} },
    StateColumn,
    { id: 'location', label: '위치', width: 300, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'speed', label: '속도(Km/h)', width: 90, show: true, option:{align: 'right', type: TableColumnType.FLOAT} },
    { id: 'svcCondValue', label: '운행상태', width: 90, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'distKm', label: '운행거리(Km)', width: 100, show: true, option:{align: 'right', type: TableColumnType.FLOAT} },
    { id: 'sessionDist', label: '범주내 운행거리', width: 120, show: true, option:{align: 'right', type: TableColumnType.FLOAT} },
    //{ id: 'tachoDist', label: '타코누적거리', width: 100, show: true, option:{align: 'right', type: TableColumnType.FLOAT} },
    //{ id: 'tachoSpeed', label: '타코속도(Km/h)', width: 100, show: true, option:{align: 'right', type: TableColumnType.FLOAT} },
    { id: 'tempr1', label: '전면온도', width: 70, show: true, option:{align: 'right', type: TableColumnType.FLOAT} },
    { id: 'tempr3', label: '중면온도', width: 70, show: true, option:{align: 'right', type: TableColumnType.FLOAT} },
    { id: 'tempr2', label: '후면온도', width: 70, show: true, option:{align: 'right', type: TableColumnType.FLOAT} },
    //{ id: 'tempr4', label: '온도4', width: 70, show: false, option:{align: 'right', type: TableColumnType.FLOAT} },
    //{ id: 'pwrTypeValue', label: '전원타입', width: 80, show: true, option:{align: 'center', type: TableColumnType.TEXT} },
    { id: 'posSysValue', label: '위치타입', width: 80, show: true, option:{align: 'center', type: TableColumnType.TEXT} },
    { id: 'poiName', label: '출발/도착지', width: 100, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'bcdEventValue', label: '출발/도착', width: 100, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'irActionName', label: '업무상태', width: 100, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    //{ id: 'roadName', label: '도로', width: 100, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    //{ id: 'roadMaxSpeed', label: '허용속도', width: 80, show: true, option:{align: 'center', type: TableColumnType.INTEGER} },
    //{ id: 'batteryVolt', label: '배터리전압', width: 90, show: true, option:{align: 'right', type: TableColumnType.FLOAT} },

];

const EmptyDuration = {from:null, till:null};

export default function VehRouteListMini({
    vehPos,
    durationGiven,
	maxHeight,
	maxWidth
}) {
    const [route, setRoute] = useState([]);
    const [duration, setDuration] = useState(EmptyDuration);
    const [itemSelected, setItemSelected] = useState(null);
    const [responseAlert, setResponseAlert] = useState(null);
    const clientSize = useClientSize();

    // ##### Call GraphQL to get List #####
    const [getVehRouteList, responseList] = useLazyQuery(LIST_VEH_ROUTE, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetList(data, option)},
		onError: (error) => {setResponseAlert({open:true, error: error, title: "경로조회 오류"})}
    });

    useEffect(()=>{
        setRoute([]);
        if(vehPos) {
            if(durationGiven) {
                if(durationGiven.from && durationGiven.till) {
                    setDuration(durationGiven);
                    getVehRouteList({variables: {vehId: vehPos.vehId, timeFrom: durationGiven.from, timeTill: durationGiven.till}});
                }
                else setDuration(EmptyDuration);
            }
            else {
                if(vehPos.gpsTime) {
                    if(vehPos.gpsTime === AppWord.NOT_REAL_GPS_TIME) setDuration(EmptyDuration);
                    else {
                        const djs = dayjs(vehPos.gpsTime);
                        const date = djs.toDate();
                        const from = ValueUtil.getYmdHmsInputText(date, 5*3600);
                        setDuration({from:from, till: vehPos.gpsTime});
                        getVehRouteList({variables: {vehId: vehPos.vehId, timeFrom: from, timeTill: vehPos.gpsTime}});
                    }
                }
                else setDuration(EmptyDuration);
            }
        }
        else setDuration(EmptyDuration);

    }, [vehPos, durationGiven, getVehRouteList]);

    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteGetList = (data, clientOption) => {
        let gpsTimeSel = itemSelected ? itemSelected.gpsTime : undefined;

        if(data.vehRouteList) {
            const newRoute = [];
            let sdist = 0;
            let preDist = 0;
            let i = 0;
            for(const p of data.vehRouteList) {
                if(p.distKm > preDist) {
                    if(i>0) {
                        sdist += (p.distKm - preDist);
                    }
                    preDist = p.distKm;
                }
                p.sessionDist = sdist;
                if(p.distKm > 0) i++;
                newRoute.push(p);

                if(gpsTimeSel) {
                    setItemSelected(p);
                    gpsTimeSel = undefined;
                }
            }
            setRoute(newRoute);
        }
    };

    const onSelectItem = (item) => {
        setItemSelected(item);
    };


	const height = maxHeight;
	const width = maxWidth;
	
    const TableHeight = height - clientSize.HeaderToolBoxHeight
        - clientSize.SmallBoxPadding * 2 - 2;

	//const isAdmin = ValueUtil.isCustAdmin(sessionInfo);

    return(
        <VehRouteListContainer>
            <HeaderBox>
                {duration.from} 부터 {duration.till} 까지
            </HeaderBox>
            <FlexyTable
                name="veh_route_list_mini"
                uniqueKey="gpsTime"
                columns={TableColumns}
                records={route}
                onClickOneRow={onSelectItem}
                selected={itemSelected ? [itemSelected] : null}
            />
            <ResponseAlert open={responseAlert ? responseAlert.open : false}
                alertData={responseAlert}
                onClose={() => {setResponseAlert(null)}}/>
        </VehRouteListContainer>
    );

}
/*


            ///<PanTable
                name="veh_route_list_mini"
                uniqueKey="gpsTime"
                height={TableHeight} width={width}
                columns={TableColumns}
                records={route}
                tools={[]}
				onClickOneRow={onSelectItem}
				selected={itemSelected ? [itemSelected] : null}
            />

*/